window.addEventListener('DOMContentLoaded', () => {
  const howToSliderElement = document.querySelector('.how-to-wear .how-to-wear__slider');
  const howToSliderSlides = howToSliderElement.querySelectorAll('.how-to-wear__slide');
  const sliderControls = document.querySelector('.how-to-wear .buttons');
  const btnNext = sliderControls.querySelector('.btn-next');
  const btnPrev = sliderControls.querySelector('.btn-prev');
  const mediaMobile = window.matchMedia('(max-width: 749px)');
  let sliderInitialized = false;

  function init(sliderElement) {
    if (!sliderCondtionsMet()) return;
    sliderInitialized = true;
    let howToSlider = initSlider(sliderElement);
    sliderElement.setAttribute('style', `--numberOfSlides: ${howToSlider.slides.length}`);

    return howToSlider;
  }

  function sliderCondtionsMet() {
    return mediaMobile.matches || howToSliderSlides.length > 3;
  }

  function initSlider(sliderElement) {
    const slider = new Flickity(sliderElement, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      wrapAround: true,
      imagesLoaded: true,
      selectedAttraction: 0.02,
      friction: 0.3,
    });

    initSliderControls(slider);
    initSliderChangeListeners(slider);
    resizeSlider(sliderElement, slider, 300);

    return slider;
  }

  function initSliderControls(slider) {
    sliderControls.addEventListener('click', (event) => {
      if (btnNext.contains(event.target)) {
        slider.next(true, false);
      } else if (btnPrev.contains(event.target)) {
        slider.previous(true, false);
      }
    });
  }

  function initSliderChangeListeners(slider) {
    slider.on('change', function (index) {
      if (index != 0 && mediaMobile.matches) {
        sliderControls.classList.add('hidden');
      } else {
        sliderControls.classList.remove('hidden');
      }
    });
  }

  function resizeSlider(sliderElement, slider, timeout) {
    window.setTimeout(() => {
      if (sliderElement.querySelector('.flickity-viewport').offsetHeight != sliderElement.querySelector('img').offsetHeight) {
        slider.resize();
      }
    }, timeout);
  }

  let howToSlider = init(howToSliderElement);

  const sliderResizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      if (sliderInitialized == false && mediaMobile.matches) {
        sliderInitialized = true;
        howToSlider = initSlider(entry.target);
      } else if (!mediaMobile.matches && sliderInitialized == true && howToSlider) {
        howToSlider.destroy();
        sliderInitialized = false;
      }
    });
  });

  sliderResizeObserver.observe(howToSliderElement);
});
